module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancelLabel":"Cancel","chooseDriver":"Select Driver","name":"Name","phone":"Phone","email":"Mail","searchPlaceholder":"Search text","title":"Search for Driver"},"no":{"cancelLabel":"Avbryt","chooseDriver":"Velg Sjåfør","name":"Navn","phone":"Telefon","email":"E-post","searchPlaceholder":"Søketekst","title":"Søk etter sjåfør"}}')
  delete Component.options._Ctor
}
